import { all } from 'redux-saga/effects'

import { getSaga } from './get/saga'

export function* scheduleLinkSaga() {
  yield all([getSaga()])
}
